import { ITags, Level, IExtra } from '../defines/sentryLog';
import { getWebUser } from './gatherUtil';

declare global {
  interface Window {
    Sentry: any;
  }
}
export interface Scope {
  setLevel: Function;
  setTag: Function;
  setExtra: Function;
  setUser: Function;
}
export default (
  title: string,
  level: Level = Level.ERROR,
  extra: IExtra = {},
  tag: ITags = {},
) => {
  if (window.Sentry) {
    window.Sentry.withScope(async (scope: Scope) => {
      scope.setLevel(level);

      Object.keys(tag).forEach((tagName) => {
        scope.setTag(tagName, tag[tagName]);
      });

      Object.keys(extra).forEach((extraName) => {
        scope.setExtra(extraName, extra[extraName]);
      });
      const webUser = await getWebUser();
      if (webUser.uid) {
        const {
          id,
          uid,
          loginId,
          realName = '无名氏',
          nickName,
          phoneNumber,
        } = webUser;
        scope.setUser({
          id, uid, loginId, realName, phoneNumber, nickName,
        });
      }

      if (level === 'error') {
        window.Sentry.captureException(title);
      } else {
        window.Sentry.captureMessage(title);
      }
    });
  } else {
    console.log(title, level, extra, tag);
  }
};
